import { GUIDED_HIGHLIGHTING_SKILLS_META } from "@/view/GuidedHighlightingContainer/utils/GuidedHighlighting.constants";
import { IAnnotationDecoration } from "@/view/TiptapArticleBody/extensions/TextHighlighting";
import { IGuidedHighlightingQuestion } from "@/view/utils/useGuidedHighlightingStudent/types";
import { GUIDED_HIGHLIGHTING_ANNOTATION_STYLES } from ".";

export const getCorrectGuidedHighlightingAnnotations = (
  activeGuidedHighlightingQuestion: IGuidedHighlightingQuestion,
): IAnnotationDecoration[] => {
  const { startIndex, endIndex, suggestedAnswer } =
    activeGuidedHighlightingQuestion;

  const annotations = [];

  if (startIndex !== undefined && endIndex !== undefined) {
    // User response, Incorrect
    annotations.push({
      startIndex,
      endIndex,
      style: GUIDED_HIGHLIGHTING_ANNOTATION_STYLES.incorrect,
    });
  } else {
    console.error("Unable to identify text selection indexes");
  }

  const {
    prosemirrorStartIndex: correctStartIndex,
    prosemirrorEndIndex: correctEndIndex,
  } = suggestedAnswer;

  // Correct answer
  annotations.push({
    startIndex: correctStartIndex,
    endIndex: correctEndIndex,
    style: GUIDED_HIGHLIGHTING_ANNOTATION_STYLES.correct,
  });

  return annotations;
};

export const getUserSelectionAnnotations = (
  activeGuidedHighlightingQuestion: IGuidedHighlightingQuestion,
): IAnnotationDecoration[] => {
  const { startIndex, endIndex, selectedText, readingSkill } =
    activeGuidedHighlightingQuestion;

  if (!selectedText || startIndex === undefined || endIndex === undefined)
    return [];

  const skillMetadata = GUIDED_HIGHLIGHTING_SKILLS_META[readingSkill];

  const { penName, background, borderColor } =
    GUIDED_HIGHLIGHTING_ANNOTATION_STYLES.default;

  const style = {
    penName,
    background: skillMetadata?.color || background,
    borderColor: skillMetadata?.BadgeColor || borderColor,
  };

  const annotation: IAnnotationDecoration = {
    startIndex,
    endIndex,
    style,
  };

  return [annotation];
};
